<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <transition-group name="fadeInUp" mode="in-out">
      <!-- Start Main Loader -->
      <MainLoader key="loader" v-if="loading" />
      <!-- End Main Loader -->

      <div key="main" v-else>
        <!-- Start Statistics Card-->
        <div class="order-details-page mb-5">
          <div class="row">
            <div class="col-sm-6 col-md-4 col-xxl-3">
              <div class="wrraper">
                <stats-card
                  title="قيمة المكافأة"
                  :number="allData.amount"
                ></stats-card>
              </div>
            </div>

            <div class="col-sm-6 col-md-4 col-xxl-3">
              <div class="wrraper">
                <stats-card
                  title="عدد الطلبات المطلوبة"
                  :number="allData.orders_count"
                ></stats-card>
              </div>
            </div>

            <div class="col-sm-6 col-md-4 col-xxl-3">
              <div class="wrraper">
                <stats-card
                  title="عدد السائقين المستحقين"
                  :number="allData.drivers_get_bouns_count"
                ></stats-card>
              </div>
            </div>

            <div class="col-sm-6 col-md-4 col-xxl-3">
              <div class="wrraper">
                <stats-card
                  title="الحالة"
                  :number="allData.is_active ? 'فعال' : 'غير فعال'"
                ></stats-card>
              </div>
            </div>

            <div class="col-sm-6 col-md-4">
              <div class="wrraper">
                <stats-card
                  title="تاريخ البدء"
                  :number="allData.from"
                ></stats-card>
              </div>
            </div>

            <div class="col-sm-6 col-md-4">
              <div class="wrraper">
                <stats-card
                  title="تاريخ الانتهاء"
                  :number="allData.to"
                ></stats-card>
              </div>
            </div>

            <div class="col-sm-6 col-md-4">
              <div class="wrraper">
                <stats-card
                  title="تاريخ الإضافة"
                  :number="allData.created_at"
                ></stats-card>
              </div>
            </div>
          </div>
          <hr class="line" />
          <div class="product-details mt-10">
            <div class="row">
              <div
                class="col-12 d-flex justify-content-between align-items-center mb-5"
              >
                <h2 class="title mb-0">
                  سجل السائقين المستحقين للمكافأة
                  <span class="badge-count" v-if="drivers_paginations.total"
                    >({{ drivers_paginations.total }})</span
                  >
                </h2>
              </div>

              <!-- Start Drivers Grid -->
              <div class="col-12" v-if="!drivers_loading">
                <div class="row" v-if="drivers.length">
                  <div
                    class="col-sm-6 col-md-4 col-lg-3 mb-4"
                    v-for="driver in drivers"
                    :key="driver.id"
                  >
                    <div class="driver-card">
                      <!-- Driver Header: Image & Status -->
                      <div class="driver-card-header">
                        <div class="image-wrapper">
                          <img
                            :src="driver.image"
                            :alt="driver.full_name"
                            @click="show_model_1"
                          />
                          <div
                            class="status-indicator"
                            :class="{
                              online: !driver.is_stop_service,
                              offline: driver.is_stop_service,
                            }"
                          ></div>
                        </div>
                        <div class="badges">
                          <v-chip
                            v-if="driver.is_ban"
                            x-small
                            color="error"
                            dark
                            label
                            >محظور</v-chip
                          >
                          <v-chip
                            v-if="driver.is_stop_service"
                            x-small
                            color="warning"
                            dark
                            label
                            >الخدمة متوقفة</v-chip
                          >
                          <v-chip
                            v-if="driver.is_admin_active_user"
                            x-small
                            color="success"
                            dark
                            label
                            >مفعل</v-chip
                          >
                        </div>
                      </div>

                      <!-- Driver Info -->
                      <div class="driver-card-body">
                        <h3 class="name">{{ driver.full_name }}</h3>

                        <div class="info-item">
                          <v-icon small>fal fa-phone</v-icon>
                          <span>{{ driver.phone_complete_form }}</span>
                        </div>

                        <div class="info-item">
                          <v-icon small>fal fa-id-card</v-icon>
                          <span>{{ driver.id_number }}</span>
                        </div>

                        <div class="info-item" v-if="driver.region">
                          <v-icon small>fal fa-map-marker-alt</v-icon>
                          <span>{{ driver.region.name }}</span>
                        </div>

                        <div class="info-item date">
                          <v-icon small>fal fa-calendar-alt</v-icon>
                          <span>انضم في: {{ driver.created_at }}</span>
                        </div>
                      </div>

                      <!-- Driver Actions -->
                      <div class="driver-card-footer">
                        <v-btn
                          block
                          outlined
                          color="primary"
                          small
                          @click="showDriverProfile(driver)"
                        >
                          عرض الملف الشخصي
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Empty State -->
                <div class="empty-state text-center py-10" v-else>
                  <v-icon size="64" color="grey lighten-1"
                    >fal fa-users-slash</v-icon
                  >
                  <p class="mt-4 grey--text">
                    لا يوجد سائقين مستحقين لهذه المكافأة حالياً
                  </p>
                </div>
              </div>

              <!-- Loading State -->
              <div class="col-12 text-center py-10" v-else>
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <p class="mt-4">جاري تحميل قائمة السائقين...</p>
              </div>

              <!-- Pagination -->
              <div
                class="col-12 d-flex justify-content-end mt-5"
                v-if="drivers_paginations.last_page > 1"
              >
                <v-pagination
                  v-model="drivers_paginations.current_page"
                  :length="drivers_paginations.last_page"
                  @input="getDrivers"
                  circle
                  color="primary"
                ></v-pagination>
              </div>
            </div>
          </div>
        </div>
        <base-model
          @closeModel="model_1.show_model = false"
          :show="model_1.show_model"
        >
          <div class="image">
            <img
              v-if="model_1.model_img_src"
              :src="model_1.model_img_src"
              alt="..."
            />
          </div>
        </base-model>
        <!-- End Statistics Card-->
        <!-- Start:: Text Content Modal -->
        <DeleteModel
          :id="allData.id"
          @toggleModal="toggleDeleteModal"
          :modalIsActive="deleteModalIsOpen"
          :elementIdToGet="deleteItemToShow"
        />
        <!-- End:: Text Content Modal -->
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Start:: Importing Modals
import DeleteModel from "@/components/Modals/DeleteModel.vue";
// End:: Importing Modals

export default {
  props: ["id"],
  name: "Withdraw",

  components: {
    DeleteModel,
  },

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.orders.title"),
          disabled: true,
          href: "",
        },

        // {
        //   text: this.$t("breadcrumb.transaction.products"),
        //   disabled: true,
        //   href: "",
        // },
      ],

      // ========== Statistics
      statisticsItem: {},
      rows: null,

      // ========== Top Section
      search: "",
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      rejectedReason: "",

      deleteModalIsOpen: false,
      deleteItemToShow: null,

      // ========== Your Data
      allData: null,
      drivers: [],
      couponOrders: [],

      // ========== Loading
      loading: false,
      drivers_loading: false,
      btnIsLoading: false,

      // ========== Pagination
      drivers_paginations: {
        current_page: 1,
        last_page: 1,
        total: 0,
      },
      e1: 1,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
            width: "80",
          },
          {
            text: "رقم الطلب",
            align: "center",
            value: "id",
            sortable: false,
          },
          {
            text: "اجمالي السعر",
            align: "center",
            value: "total_price",
            sortable: false,
          },
          {
            text: "اجمالي كمية المنتج",
            align: "center",
            value: "total_quantity_product",
            sortable: false,
          },
          {
            text: "حالة الدفع ؟",
            align: "center",
            value: "is_payment",
            sortable: false,
          },
          {
            text: "الحالة",
            align: "center",
            value: `status`,
            sortable: false,
            width: "200",
            padding: "2",
          },

          {
            text: "التاريخ",
            align: "center",
            value: "created_at",
            sortable: false,
          },
          {
            text: "التحكم",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Reporter",
            align: "center",
            value: "from",
            sortable: false,
          },
          {
            text: "Reported",
            align: "center",
            value: "to",
            sortable: false,
          },
          {
            text: "Report Reason",
            align: "center",
            value: "report_reason",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },

    orderStatusItems() {
      return [
        {
          label: "انتظار قبول الادارة",
          name: "pending",
        },
        {
          label: "قبول من قبل الادارة",
          name: "admin_accept",
        },
        {
          label: "الالغاء من قبل الادارة",
          name: "admin_cancel",
        },
        {
          label: "الغاء من قبل العميل",
          name: "client_cancel",
        },
        {
          label: "جاري الشحن",
          name: "admin_shipping",
        },
        {
          label: "تم التوصيل",
          name: "admin_delivered",
        },
        {
          label: "الانتهاء للعميل",
          name: "client_finished",
        },
      ];
    },
  },

  methods: {
    changeStatus(currStatus, id) {
      this.btnIsLoading = true;
      let submit_data = new FormData();
      submit_data.append("_method", "PUT");
      submit_data.append("status", currStatus);
      this.$axios({
        method: "POST",
        url: `order/${id}/change_status`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("sendSuccess"),
            position: "bottomRight",
          });
          // this.$router.push({ path: "/transactions/all-transactions" });
          this.btnIsLoading = false;
          this.setRows();
        })
        .catch((err) => {
          if (err.response.data.status == "fail") {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          }

          this.setRows();
          this.btnIsLoading = false;
        });
    },
    orderStatusList(status) {
      if (status == "pending") {
        return [
          {
            text: "قبول",
            value: "admin_accept",
          },
          { text: "رفض", value: "admin_rejected" },
        ];
      } else if (status == "admin_accept") {
        return [
          { text: "شحن", value: "admin_shipping" },
          { text: "الغاء", value: "admin_cancel" },
        ];
      } else if (status == "admin_rejected") {
        return [{ text: "الغاء", value: "admin_cancel" }];
      } else if (status == "admin_shipping") {
        return [
          { text: "تم التوصيل", value: "admin_delivered" },
          { text: "الغاء", value: "admin_cancel" },
        ];
      } else if (status == "admin_delivered") {
        return [{ text: "الغاء", value: "admin_cancel" }];
      }
    },
    // ===== Toggle Delete Modal =====
    toggleDeleteModal(item) {
      this.deleteItemToShow = item;
      this.deleteModalIsOpen = !this.deleteModalIsOpen;
    },

    // Fetch Bonus Data
    getBonusData() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: `bonus/${this.id}`,
      })
        .then((res) => {
          this.allData = res.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    // Fetch Drivers
    getDrivers() {
      this.drivers_loading = true;
      this.$axios({
        method: "GET",
        url: `bonus/${this.id}/drivers`,
        params: {
          page: this.drivers_paginations.current_page,
        },
      })
        .then((res) => {
          this.drivers = res.data.data;
          this.drivers_paginations.last_page = res.data.meta.last_page;
          this.drivers_paginations.total = res.data.meta.total;
          this.drivers_loading = false;
        })
        .catch((err) => {
          this.drivers_loading = false;
        });
    },

    showDriverProfile(driver) {
      this.$router.push({ path: `/driver/show/${driver.id}` });
    },

    getCouponOrders() {
      this.btnIsLoading = true;
      this.$axios({
        method: "GET",
        url: `coupon_addition_data/${this.id}/orders`,
      })
        .then((res) => {
          this.couponOrders = res.data.data;

          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.btnIsLoading = false;
        });
    },
    //Change Status

    showItem(item) {
      this.$router.push({ path: "/orders/show/" + item.id });
    },

    orderStatus(status) {
      let message = "";
      switch (status) {
        case "pending":
          message = "جاري التنفيذ";
          break;
        case "admin_accept ":
          message = "تم القبول";

          break;
        case "admin_shipping":
          message = "جاري الشحن";

          break;
        case "admin_delivered":
          message = "تم التوصيل";

          break;
        case "admin_rejected":
          message = "تم الرفض ";

          break;
        case "admin_cancel":
          message = "تم الالغاء";

          break;
        default:
      }
      return message;
    },
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },
  },
  created() {
    this.getBonusData();
    this.getDrivers();
  },

  // ======= hooks
};
</script>

<style lang="scss">
.order-details-page {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 11%);
  padding: 20px 0;
  h2.title {
    font-size: 14px !important;
    padding: 0 10px;
    font-weight: bold !important;
    text-align: start !important;
  }
  span.status {
    font-size: 14px;
    &.finished {
      color: #02bc77;
    }
    &.pendding {
      color: #ffc800;
    }
    &.shipping {
      color: #a900ff;
    }
  }
  .status {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0 10px;
  }
  .action {
    .v-input {
      padding: 0;
      margin: 0;
    }
    .v-input__control {
      background: #e7e7e7;
      padding: 8px;
      max-width: 200px;
      border-radius: 5px;
    }
    .v-text-field__details {
      display: none !important;
    }
    .v-input__slot {
      margin: 0;
      &::before {
        content: unset !important;
      }
    }
    .v-select__slot {
      &::after {
        content: unset !important;
      }
    }
    input[role="readonly"] {
      display: none !important;
    }
  }
  .details {
    padding: 0 10px;
    h5.title {
      color: #000;
      font-size: 14px !important;
      font-weight: bold;
      margin-bottom: 0%;
    }
    .item {
      display: flex;
      align-items: flex-start;
      .icon {
        background: #f5f5fa;
        border-radius: 50%;
        width: 50px !important;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px !important;
        * {
          color: #000;
        }
      }
      .info {
        flex: 1;
        margin-inline-start: 8px;
        background: none !important;
        p {
          font-size: 14px;
          color: #8d8d8d;
          margin-bottom: 0;
          &:not(:last-child) {
            margin-bottom: 4px;
          }
        }
      }
    }
  }
  .product-details {
    padding: 0 10px;
    h2.title {
      font-size: 18px !important;
    }
  }
  table {
    width: 100%;
    td.title {
      font-size: 16px !important;
      line-height: 1.7;
      &.status {
        font-size: 14px !important;
        padding: 0;
      }
    }
    td.value {
      font-size: 14px !important;
      font-weight: bold;
      text-align: end;

      span.status {
        justify-content: flex-end;
        padding: 0;
      }
    }
  }

  div.line {
    padding: 10px 0;
  }

  .badge-count {
    background: var(--main-color);
    color: #fff;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    vertical-align: middle;
    margin-inline-start: 8px;
  }

  // Driver Card Styles
  .driver-card {
    background: #fff;
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    padding: 20px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    height: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid #f0f0f0;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    }

    .driver-card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 15px;

      .image-wrapper {
        position: relative;
        img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          object-fit: cover;
          border: 3px solid #f8f9fa;
          cursor: pointer;
        }

        .status-indicator {
          position: absolute;
          bottom: 5px;
          right: 5px;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          border: 2px solid #fff;

          &.online {
            background-color: #28a745;
          }
          &.offline {
            background-color: #dc3545;
          }
        }
      }

      .badges {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-end;
      }
    }

    .driver-card-body {
      flex-grow: 1;

      .name {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 12px;
        text-align: start;
      }

      .info-item {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
        color: #666;
        font-size: 13px;

        i {
          color: var(--main-color);
          width: 16px;
        }

        &.date {
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px dashed #eee;
          color: #999;
        }
      }
    }

    .driver-card-footer {
      margin-top: 15px;
    }
  }

  .empty-state {
    background: #fdfdfd;
    border-radius: 20px;
    border: 2px dashed #eee;
  }
}

.btns_actions {
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    margin: 5px;
  }
}
</style>
